// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__8oXW0","label":"Labeled_label__3pQBX","divider":"Labeled_divider__2oAKN"};